<div class="modal-body d-flex flex-column justify-content-center align-items-center">
  <div class="loading-container mt-20 mb-30">
    <div class="pulse" [ngClass]="{'pulse-success': !isLoading && isSuccess}">
      <i
        class="fa-sharp"
        [ngClass]="{
          'fa-phone text-white': isLoading,
          'fa-check text-white': !isLoading && isSuccess
        }"
      ></i>
    </div>
    <p class="mt-50 loading-text">
      <span *ngIf="isLoading">{{ 'MODAL.RETRYING_CONTACT' | translate }}</span>
      <span
        *ngIf="!isLoading && isSuccess"
        class="text-success"
        >{{ 'MODAL.CONTACT_RENEWED' | translate }}</span
      >
    </p>
  </div>
</div>
